module.exports = (latKey = 'lat', lngKey = 'lng') -> Ember.computed latKey, lngKey, (key, value) ->
	if value
		@set latKey, value.lat
		@set lngKey, value.lng
	
	lat = @get(latKey)
	lng = @get(lngKey)
	@L.latLng lat, lng
